module.exports = __webpack_public_path__ + "img/Pinterest.68851b96.svg";